import './Price.less'
import Button from '../../../Button'

export function ResumenCompra({
  product,
  price = product?.price,
  qty,
  setQty,
  addToCartHandler,
}) {
  const currentPrice = price ?? product?.price ?? 0;

  return (
    // <div className="card-detail card-body">
    <div>
      <ul>
        <li>
          <div className="products">
            <div>Price</div>
            <div className="price">${product.price}</div>
          </div>
        </li>
        <li>
          <div className="products">
            <div>Status</div>
            <div>
              {product.countInStock > 0 ? (
                <span className="success">In Stock</span>
              ) : (
                <span className="danger">Unavaible</span>
              )}
            </div>
          </div>
        </li>

        {product?.countInStock > 0 && (
          <>
            <li>
              <div className="products">
                <div>Qty</div>
                <div>
                  <select
                    value={qty}
                    onChange={e => setQty(Number(e.target.value))}
                  >
                    {[...Array(product.countInStock).keys()].map(
                      x => (
                        <option key={x + 1} value={x + 1}>
                          {x + 1}
                        </option>
                      )
                    )}
                  </select>
                </div>
              </div>
            </li>
            <li>
              {/* <button
                onClick={addToCartHandler}  
                className="btn block"
              >
                {' '}
                Add to Cart
              </button> */}
              <Button onClick={addToCartHandler}> Add to Cart</Button>
            </li>
          </>
        )}
      </ul>
    </div >
  )
}